import OfflineDocumentsPage from './OfflineDocuments';

export default OfflineDocumentsPage;
